export function currencyFormat(
  value: number | string,
  currency: string = "USD",
  locale: string = "en-US",
): string {
  return value.toLocaleString(locale, {
    style: "currency",
    currency,
  });
}
